import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onClearFilters }) => {
  const classTypeOptions = [
    { value: 'all', label: 'All Classes' },
    { value: 'yoga', label: 'Yoga' },
    { value: 'hiit', label: 'HIIT' },
    { value: 'strength', label: 'Strength Training' },
    { value: 'cardio', label: 'Cardio' },
    { value: 'cycling', label: 'Cycling' },
    { value: 'pilates', label: 'Pilates' },
    { value: 'boxing', label: 'Boxing' },
    { value: 'dance', label: 'Dance' }
  ];

  const difficultyOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];

  const timeOptions = [
    { value: 'all', label: 'Any Time' },
    { value: 'morning', label: 'Morning (6AM - 12PM)' },
    { value: 'afternoon', label: 'Afternoon (12PM - 5PM)' },
    { value: 'evening', label: 'Evening (5PM - 9PM)' }
  ];

  const instructorOptions = [
    { value: 'all', label: 'All Instructors' },
    { value: 'sarah-johnson', label: 'Sarah Johnson' },
    { value: 'mike-chen', label: 'Mike Chen' },
    { value: 'emily-rodriguez', label: 'Emily Rodriguez' },
    { value: 'david-kim', label: 'David Kim' },
    { value: 'lisa-patel', label: 'Lisa Patel' }
  ];

  const availabilityOptions = [
    { value: 'all', label: 'All Classes' },
    { value: 'available', label: 'Available Only' },
    { value: 'waitlist', label: 'Waitlist Available' }
  ];

  const hasActiveFilters = () => {
    return (filters?.classType !== 'all' ||
    filters?.difficulty !== 'all' ||
    filters?.time !== 'all' ||
    filters?.instructor !== 'all' ||
    filters?.availability !== 'all' || filters?.search !== '');
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="Filter" size={24} color="var(--color-primary)" />
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Filter Classes
          </h3>
        </div>
        {hasActiveFilters() && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <Input
          type="search"
          placeholder="Search classes..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="lg:col-span-3"
        />

        <Select
          label="Class Type"
          options={classTypeOptions}
          value={filters?.classType}
          onChange={(value) => onFilterChange('classType', value)}
        />

        <Select
          label="Difficulty"
          options={difficultyOptions}
          value={filters?.difficulty}
          onChange={(value) => onFilterChange('difficulty', value)}
        />

        <Select
          label="Time"
          options={timeOptions}
          value={filters?.time}
          onChange={(value) => onFilterChange('time', value)}
        />

        <Select
          label="Instructor"
          options={instructorOptions}
          value={filters?.instructor}
          onChange={(value) => onFilterChange('instructor', value)}
          searchable
        />

        <Select
          label="Availability"
          options={availabilityOptions}
          value={filters?.availability}
          onChange={(value) => onFilterChange('availability', value)}
        />
      </div>
      {hasActiveFilters() && (
        <div className="flex flex-wrap items-center gap-2 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          {filters?.classType !== 'all' && (
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm">
              {classTypeOptions?.find(opt => opt?.value === filters?.classType)?.label}
              <button
                onClick={() => onFilterChange('classType', 'all')}
                className="ml-2 hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
          {filters?.difficulty !== 'all' && (
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm">
              {difficultyOptions?.find(opt => opt?.value === filters?.difficulty)?.label}
              <button
                onClick={() => onFilterChange('difficulty', 'all')}
                className="ml-2 hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
          {filters?.time !== 'all' && (
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm">
              {timeOptions?.find(opt => opt?.value === filters?.time)?.label}
              <button
                onClick={() => onFilterChange('time', 'all')}
                className="ml-2 hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
          {filters?.instructor !== 'all' && (
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm">
              {instructorOptions?.find(opt => opt?.value === filters?.instructor)?.label}
              <button
                onClick={() => onFilterChange('instructor', 'all')}
                className="ml-2 hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
          {filters?.availability !== 'all' && (
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary text-sm">
              {availabilityOptions?.find(opt => opt?.value === filters?.availability)?.label}
              <button
                onClick={() => onFilterChange('availability', 'all')}
                className="ml-2 hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterPanel;